import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { OPEN_ADD_COIN_EVENT } from 'utils/onboardingWalkthrough';

export const getDashboardNavActive = (pathname) => {
  if (pathname === '/dashboard/assets' || pathname.startsWith('/dashboard/assets/')) {
    return 'assets';
  }
  if (pathname === '/dashboard/all-coin') {
    return 'all-coin';
  }
  return 'category';
};

export function useDashboardNav() {
  const location = useLocation();
  const [active, setActive] = useState(() => getDashboardNavActive(location.pathname));
  const [visibleCategory, setVisibleCategory] = useState(false);
  const [showCoin, setShowCoin] = useState(false);

  useEffect(() => {
    setActive(getDashboardNavActive(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    const openAddCoin = () => setShowCoin(true);
    window.addEventListener(OPEN_ADD_COIN_EVENT, openAddCoin);
    return () => window.removeEventListener(OPEN_ADD_COIN_EVENT, openAddCoin);
  }, []);

  return {
    active,
    visibleCategory,
    setVisibleCategory,
    showCoin,
    setShowCoin,
    toggleVisibleCategory: () => setVisibleCategory((prev) => !prev),
    openAddCoin: () => setShowCoin(true),
  };
}
